var ImageData = (function () {
    function ImageData(width, height) {
        this.width = width;
        this.height = height;
        this.data = new Uint8Array(width * height * 4);
    }
    return ImageData;
}());
export { ImageData };



// WEBPACK FOOTER //
// ../dist/lib/image/ImageData.js